import { useQuery } from 'react-query';

import {
  Grid,
  Flex,
  Text,
  Stat,
  StatLabel,
  StatNumber,
  Box,
} from '@chakra-ui/react';

import { apiService } from 'services/ApiService';

import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';

const StatItem = ({ label, value, color }) => (
  <Stat>
    <StatLabel fontSize="14px" color="#9FABCB" fontWeight="500" mb="8px">
      {label}
    </StatLabel>

    <StatNumber fontSize="30px" fontWeight="600" color={color} lineHeight="1">
      {value}
    </StatNumber>
  </Stat>
);

function SummaryCard() {
  const { data, isLoading } = useQuery({
    queryKey: ['stats-summary'],
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: async () => {
      const response = await apiService.getStatsSummary();
      return response.data;
    },
  });

  return (
    <Card minH={301} padding="24px 20px" w="100%">
      <Flex justifyContent="center" mb="24px">
        <Text variant="title-lg">Summary</Text>
      </Flex>

      <CardBody p="0">
        <Box w="100%">
          {isLoading ? (
            <Flex justifyContent="center" alignItems="center" height="315px">
              <Text>Loading summary...</Text>
            </Flex>
          ) : (
            <Grid
              templateColumns={{
                base: '1fr',
                md: 'repeat(2, 1fr)',
              }}
              gap={8}
            >
              <StatItem
                label="Revenue"
                value={`$${data.revenue.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`}
                color="#1870EC"
              />

              <StatItem
                label="POS Transactions"
                value={data.posTxs.toLocaleString()}
                color="#FFB91B"
              />

              <StatItem
                label="Fuel Sales"
                value={data.fuelSales.toLocaleString()}
                color="#00C7BE"
              />

              <StatItem
                label="Coffee Sales"
                value={data.coffeeSales.toLocaleString()}
                color="#BB4A02"
              />

              <StatItem
                label="Active Users"
                value={data.activeUsers.toLocaleString()}
                color="#57D175"
              />
            </Grid>
          )}
        </Box>
      </CardBody>
    </Card>
  );
}

export default SummaryCard;
